import React, { Component } from 'react';
import ReactStopwatch from 'react-stopwatch';
import moment from 'moment';

class StopwatchTimers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            privilage:0,
            diff_hours:0,
            diff_minutes:0
        }
    }
    componentDidMount() {
        let { timer_data } = this.props
        var diff_minutes=0;
        var  diff_hours=0;
        if(timer_data.break_status==1){
            var now = moment(new Date()); //todays date
            var end = moment(timer_data.latest_break_time); // another date
            diff_minutes=now.diff(end, 'minutes');
            diff_hours=now.diff(end, 'hours')
            if(diff_hours!==0){
                diff_minutes=(diff_minutes-(diff_hours*60));  
            }
            this.setState({ 'data': timer_data,diff_minutes:diff_minutes,diff_hours:diff_hours })
        }
        if(timer_data.break_status==0 && timer_data.latest_idle_time){
            var now = moment(new Date()); //todays date
            var end = moment(timer_data.latest_idle_time); // another date
            diff_minutes=now.diff(end, 'minutes');
            diff_hours=now.diff(end, 'hours')
            if(diff_hours!==0){
                diff_minutes=(diff_minutes-(diff_hours*60));  
            }  
            this.setState({ 'data': timer_data,diff_minutes:diff_minutes,diff_hours:diff_hours })
        }
        if(timer_data.break_status==0 && timer_data.current_token_count){
            var now = moment(new Date()); //todays date
            var end = moment(timer_data.latest_assigned_time); // another date
            diff_minutes=now.diff(end, 'minutes');
            diff_hours=now.diff(end, 'hours')
            if(diff_hours!==0){
                diff_minutes=(diff_minutes-(diff_hours*60));  
            }
            this.setState({ 'data': timer_data,diff_minutes:diff_minutes,diff_hours:diff_hours })  
        }
        
    }
    componentDidUpdate(prevProps, prevState) {
        let {timer_data,  lastRefeshTime} = this.props
        if(prevProps.lastRefeshTime!==lastRefeshTime){
            console.log('prevProps',prevProps)
            console.log('this.props',lastRefeshTime)  
           
            var diff_minutes=0;
            var  diff_hours=0;
            if(timer_data.break_status==1){
                var now = moment(new Date()); //todays date
                var end = moment(timer_data.latest_break_time); // another date
                diff_minutes=now.diff(end, 'minutes');
                diff_hours=now.diff(end, 'hours')
                if(diff_hours!==0){
                    diff_minutes=(diff_minutes-(diff_hours*60));  
                }
                this.setState({ 'data': timer_data,diff_minutes:diff_minutes,diff_hours:diff_hours })
            }
            if(timer_data.break_status==0 && timer_data.latest_idle_time){
                var now = moment(new Date()); //todays date
                var end = moment(timer_data.latest_idle_time); // another date
                diff_minutes=now.diff(end, 'minutes');
                diff_hours=now.diff(end, 'hours')
                if(diff_hours!==0){
                    diff_minutes=(diff_minutes-(diff_hours*60));  
                }  
                this.setState({ 'data': timer_data,diff_minutes:diff_minutes,diff_hours:diff_hours })
            }
            if(timer_data.break_status==0 && timer_data.current_token_count){
                var now = moment(new Date()); //todays date
                var end = moment(timer_data.latest_assigned_time); // another date
                diff_minutes=now.diff(end, 'minutes');
                diff_hours=now.diff(end, 'hours')
                if(diff_hours!==0){
                    diff_minutes=(diff_minutes-(diff_hours*60));  
                }
                this.setState({ 'data': timer_data,diff_minutes:diff_minutes,diff_hours:diff_hours })  
            }
        }
    }

render(){
    let {diff_hours,diff_minutes,data}=this.state
    return(
        <div>
            <ReactStopwatch
    seconds={30}
    minutes={0}
    hours={0}
    render={({hours, minutes, seconds }) => {
        var current_hours=0;
        var  current_minutes=0;
        var current_seconds=0;
        if(data.break_status==1){
            var now = moment(new Date()); //todays date
            var end = moment(data.latest_break_time); // another date
            const duration = moment.duration(now.diff(end));
            current_hours = duration.hours();
            current_minutes = duration.minutes();
            // current_seconds = duration.seconds();
            current_seconds = Math.max(duration.seconds(), 0);
        }
        if(data.break_status==0 && data.latest_idle_time){
            
            var now = moment(new Date()); //todays date
            var end = moment(data.latest_idle_time); // another date
            const duration = moment.duration(now.diff(end));
            current_hours = duration.hours();
            current_minutes = duration.minutes();
            // current_seconds = duration.seconds();
            current_seconds = Math.max(duration.seconds(), 0);
        }
        if(data.break_status==0 && data.current_token_count){
            var now = moment(new Date()); //todays date
            var end = moment(data.latest_assigned_time); // another date
            const duration = moment.duration(now.diff(end));
            current_hours = duration.hours();
            current_minutes = duration.minutes();
            // current_seconds = duration.seconds();
            current_seconds = Math.max(duration.seconds(), 0);
        }
      return (
        <div>
            {/* <h3 style={{ 'fontSize': '2pc',paddingRight:'50px',background:'#fff',color:data.break_status==0&&data.current_token_count && data.privilege_time_duration&&data.privilege_time_duration!==0 &&(diff_minutes+(seconds/60))<data.privilege_time_duration ?'green':data.break_status==0&&data.current_token_count&& data.privilege_time_duration&&data.privilege_time_duration!==0 &&(diff_minutes)>=data.privilege_time_duration ?'red':'black' }}>{hours?hours+diff_hours+'h:':diff_hours+'h:'}{minutes?minutes+diff_minutes+'m:':diff_minutes+'m:'}<span className="position-absolute">{current_seconds?current_seconds+'s':null}</span></h3> */}
            <h3 style={{ 'fontSize': '2pc',paddingRight:'50px',background:'#fff',color:data.break_status==0&&data.current_token_count && data.privilege_time_duration&&data.privilege_time_duration!==0 &&(current_minutes+(current_seconds/60))<data.privilege_time_duration ?'green':data.break_status==0&&data.current_token_count&& data.privilege_time_duration&&data.privilege_time_duration!==0 &&(current_minutes)>=data.privilege_time_duration ?'red':'black' }}>{current_hours?current_hours+'h:':0+'h:'}{current_minutes?current_minutes+'m:':0+'m:'}<span className="position-absolute">{current_seconds?current_seconds+'s':null}</span></h3>

        </div>
      );
    }}

   />
        </div>

    )
}
}
export default StopwatchTimers;